var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.selected,"placeholder":_vm.plc || _vm.$t(`message.users`),"filterable":"","clearable":""},on:{"input":_vm.dispatch}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name +' '+ item.surname +' '+ (item.patronymic? item.patronymic: ''),"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }